import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../lib/route-guard.js';
import { CustomReportsPage } from '../../modules/custom-reports/custom-reports-page.js';

export const Route = createFileRoute('/custom-reports/')({
  component: () => (
    <RouteGuard route="/custom-reports">
      <CustomReportsPage />
    </RouteGuard>
  ),
});
